"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContextHostUI = function () {
  /**
   * @param {String} locationId the id of the specific location within the UITab where the app is mounted
   * @param {...*} rest
   * @constructor
   */
  function ContextHostUI(_ref) {
    var locationId = _ref.locationId,
        rest = (0, _objectWithoutProperties3.default)(_ref, ["locationId"]);
    (0, _classCallCheck3.default)(this, ContextHostUI);

    this.props = (0, _extends3.default)({ locationId: locationId }, rest);
  }

  /**
   * The id of the location within the helpdesk UI where this application is shown
   *
   * @public
   * @return {String}
   */


  (0, _createClass3.default)(ContextHostUI, [{
    key: "locationId",
    get: function get() {
      return this.props.locationId.toString();
    }
  }]);
  return ContextHostUI;
}();

exports.default = ContextHostUI;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/ContextHostUI.js
// module id = 325
// module chunks = 0